module.exports = __webpack_public_path__ + "static/media/abbie.25b8dd01.jpeg";